export const ROUTES = {
  HOME: '/',
  START: '/start',
  LOGIN: '/login',
  SIGNUP: '/signup',
  CHAT: '/chat',
  CHAT_CONVERSATION: '/chat/:conversationId',
  // Voice chat. Deliberately not under /voice — that prefix is Momentum Voice's,
  // and AppShell/SidebarRight open its right sidebar for anything starting with it.
  ASSISTANT: '/assistant',
  // One route for both the new-conversation URL and a conversation's URL, so the
  // page isn't remounted when a new conversation's id is written into the address.
  ASSISTANT_CONVERSATION: '/assistant/:conversationId?',
  CHANNEL: '/channel/:channelGuid',
  CHANNEL_CONVERSATION: '/channel/:channelGuid/:conversationId',
  CHANNELS: '/channels',
  AMPS: '/amps',
  AMPS_CREATE: '/amps/create',
  AMP_CHAT: '/amp/:ampId',
  AMP_CONVERSATION: '/amp/:ampId/:conversationId',
  DASHBOARD: '/dashboard',
  SETTINGS: '/settings',
  SETTINGS_INTEGRATIONS: '/settings/integrations',
  SETTINGS_MCP: '/settings/mcp',
  SETTINGS_WEBHOOKS: '/settings/webhooks',
  SETTINGS_WEBHOOKS_REPORT: '/settings/webhooks/report',
  SETTINGS_HARNESS_TYPE: '/settings/harness-type',
  SETTINGS_INTEGRATIONS_CALLBACK: '/settings/integrations/callback',
  PROFILE: '/profile',
  VOICE: '/voice',
  DIALER: '/dialer',
  MARKETPLACE: '/marketplace',
  QUOTE_PROPOSAL: '/quote-proposal',
  QUOTE_PROPOSAL_TRANSACTION: '/quote-proposal/:transactionId',
  CARRIER_DOWNLOAD: '/carrier-download',
  CARRIER_ACCESS: '/carrier-access',
  IVANS_MONITOR: '/ivans-monitor',
  RATE_QUOTE_LINK: '/rate-quote-link',
  RATE_QUOTING: '/rate-quoting',
  COMMERCIAL_LINES_RATING: '/commercial-lines-rating',
  MOMENTUM_CLAW: '/momentum-claw',
  MOMENTUM_CLAW_CONVERSATION: '/momentum-claw/:conversationId',
  BROWSER_AGENT: '/browser-agent',
  BROWSER_AGENT_SKILLS: '/browser-agent/skills',
  WIDGETS: '/widgets',
  WIDGET_DETAIL: '/widgets/:toolId',
  MOMENTUM_COMMAND: '/momentum-kanban',
  // Optional param (not a separate path) — the bare and detail URLs must match
  // the SAME <Route>, otherwise navigating from one to the other (e.g. right as
  // a brand-new task's first AI reply starts streaming) makes React Router
  // treat it as a different route and remount MomentumCommandPage mid-stream.
  MOMENTUM_COMMAND_DETAIL: '/momentum-kanban/:taskId?',
  COMMUNICATION_CENTER: '/communication-center',
  REQUEST_EARLY_ACCESS: '/requestearlyaccess',
  ADMIN: '/admin',
  TRUCKING_APPETITE: '/trucking-appetite',
  TRUCKING_APPETITE_CONVERSATION: '/trucking-appetite/:conversationId',
  CARRIER_FINDER: '/carrier-finder',
  CARRIER_FINDER_CONVERSATION: '/carrier-finder/:conversationId',
  CLAUDE_AGENTS: '/claude-agents',
  CLAUDE_AGENT_DETAIL: '/claude-agents/:agentId',
  CLAUDE_AGENT_CHAT: '/claude-agents/:agentId/chat',
  CLAUDE_AGENTS_SKILLS: '/claude-agents/skills',
  CLAUDE_AGENTS_AGENT_CONFIG: '/claude-agents/agent-config',
  CLAUDE_AGENTS_MCP_CONFIG: '/claude-agents/mcp-config',
  PROPOSAL_VIEW: '/proposal-view/:transactionId',
  MAC_WORKFLOWS: '/mac-workflows',
  COMMISSION_SCAN: '/commission-scan',
  COI_SCAN: '/coi-scan',
  DRIVER_LICENSE_SCAN: '/driver-license-scan',
  INVOICE_SCAN: '/invoice-scan',
  LOSS_RUN_SCAN: '/loss-run-scan',
  MVR_SCAN: '/mvr-scan',
  MY_TOOLS: '/tools-marketplace',
  MY_TOOLS_LEGACY: '/my-tools',
  API_INTEGRATION_NEW: '/tools-marketplace/api-integration/new',
  API_INTEGRATION_EDIT: '/tools-marketplace/api-integration/:id/edit',
  SHARE_RESOLVE: '/share/:token',
  SHARE_AGENT_RESOLVE: '/share-agent/:token',
  SHARE_CATEGORY_RESOLVE: '/share-category/:token',
  COMMISSION_FORECAST: '/commission-forecast',
  REVIEW_QUEUE: '/review-queue',
  MOMENTUM_ROUTINES: '/momentum-routines',
  MOMENTUM_ROUTINES_DETAIL: '/momentum-routines/:routineId',
  UPSELL_INDICATOR: '/upsell-indicator',
  NAICS_CLASSIFICATION: '/naics-classification',
  HOME_OWNERS: '/home-owners',
  FENRIS_PERSONAL_LINE: '/fenris-personal-line',
  FENRIS_DRIVER_VEHICLE: '/fenris-driver-vehicle',
  DATA_ENRICHMENT_COMMERCIAL: '/data-enrichment-commercial',
  POLICY_COMPARISON: '/policy-comparison',
  POLICY_SUMMARY: '/policy-summary',
  RENEWAL_CENTER: '/renewal-center',
  CENTER_HOME: '/center/:centerId',
  // '/center/submission' itself is the generic Center launcher (CenterHomePage,
  // same as every other Center e.g. Servicing) — the opportunity tracker lives
  // one level under it as its own workspace, like Renewals under Renewal Center.
  CENTER_SUBMISSION: '/center/submission',
  CENTER_SUBMISSION_TRACKER: '/center/submission/opportunities',
  CENTER_SUBMISSION_ADD_QUOTE: '/center/submission/opportunities/add-quote/:oppId',
  CENTER_SUBMISSION_ADD_OPPORTUNITY: '/center/submission/opportunities/add-opportunity',
  DIGITAL_WORKFORCE: '/digital-workforce',
  DW_ARTIFACTS: '/dw-artifacts',
  ARTIFACTS: '/artifacts',
  ARTIFACT_DETAIL: '/artifacts/:guid',
  DATA_QUALITY_SCAN: '/data-quality-scan',
  VALCHOICE_CLASSIFICATION: '/valchoice-classification',
  MAC_APPS: '/mac-apps',
  MTM_SCAN: '/mtm-scan',
  VEHICLE_PREFILL: '/vehicle-prefill',
  ACORD_DEC_PAGES_SCAN: '/acord-dec-pages-scan',
  PREMFI_PFA_SCAN: '/premfi-pfa-scan',
  HR_CENTER: '/hr',
} as const;
